<template>
  <transition name="fade">
    <GlobalLoading v-if="isLoading" />
    <div :class="$store.state.modalStore.showSpmEmailPreview
      ? 'email-modal-container-active'
      : 'email-modal-container'
      ">
      <div class="email-cc">
        <div class="cc-label">Subject:</div>
        <input type="text" placeholder="Contoh: email1@smm.com" v-model="subject" />
      </div>
      <div class="email-cc">
        <div class="cc-label">To:</div>
        <input type="text" placeholder="Contoh: email1@smm.com" v-model="to" />
      </div>
      <div class="email-cc">
        <div class="cc-label">Cc:</div>
        <input type="text" placeholder="Contoh: email1@smm.com; email2@smm.com" v-model="email" />
      </div>
      <div class="email-textarea">
        <textarea name="" v-model="generateText"> </textarea>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="previewData()">
            {{
              $store.state.modalStore.showSpmEmailPreview
                ? 'TUTUP PREVIEW'
                : 'LIHAT PREVIEW'
            }}
          </div>
          <div class="email-button" @click="closeEmail()">CANCEL</div>
          <div class="email-button" @click="sendEmail()">SEND EMAIL</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import { api } from '../services/config'
export default {
  name: 'SpmEmail',
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      email: null,
      subject: '',
      to: '',
      customText: null,
      tempText: null,
      isLoading: false
    }
  },
  computed: {
    generateText: {
      get: function () {
        const self = this
        self.customText = `
Dengan Hormat,

Berikut kami informasikan hasil Evaluasi Kinerja ${self.$store.state.modalStore
            .spmEmail && self.$store.state.modalStore.spmEmail.supplier_name} 
dengan detail sebagai berikut:

Nama Projek: ${self.$store.state.modalStore.spmEmail &&
          self.$store.state.modalStore.spmEmail.project_name}
Total Score: ${self.$store.state.modalStore.spmEmail &&
          self.$store.state.modalStore.spmEmail.score}
Keterangan: ${self.$store.state.modalStore.spmEmail &&
          self.$store.state.modalStore.spmEmail.category}

Demikian yang dapat kami sampaikan.

Salam,
SIPM Dept.
Sinarmas Mining
`
        return this.customText
      },
      set: function (value) {
        const self = this
        self.tempText = value
      },
    },
  },
  methods: {
    beforeDestroy() {
      this.email = null
    },
    enterSend(event) {
      if (event.which === 13) {
        this.sendMail()
      }
    },
    previewData() {
      this.$store.commit('modalStore/SPM_EMAIL_PREVIEW', true)
    },
    async closeEmail() {
      const self = this
      await self.$store.commit('modalStore/SPM_EMAIL_PREVIEW', 'close')
      await self.$store.commit('modalStore/EMAIL_MODAL_CLOSE')
    },
    sendEmail() {
      const self = this
      let urlApi = `${api}/api/v1/spmnotif`
      const ccEmail = self.email && self.email.replace(/ /gi, '')

      self.isLoading = true
      axios({
        method: 'POST',
        url: urlApi,
        data: {
          cc: ccEmail,
          to: self.to,
          message: self.tempText ? self.tempText : self.customText,
          subject: self.subject,
        },
      })
        .then(({ data }) => {
          if (data) {
            self.$bvModal.hide('spm-email')
            self.$bvToast.toast(data.message, {
              title: data.status,
              toaster: 'b-toaster-top-center',
              solid: true,
              appendToast: false,
              variant: 'success',
            })
          }
          self.isLoading = false
          self.closeEmail()
          self.beforeDestroy()
        })
        .catch(error => {
          self.isLoading = false
          self.$bvToast.toast(error.response.data.message, {
            title: error.response.data.status,
            toaster: 'b-toaster-top-center',
            solid: true,
            appendToast: false,
            variant: 'danger',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
